import type React from "react";

import { translate } from "app/filters/i18nFilter";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import {
    LimitedChipItems,
} from "app/pages/sales-intelligence/common-components/filters-panel";
import { StyledDelimiter } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/ios/styles";
import { FlexRowWrap } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/styles";
import type { IosIdentifierType } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/types";
import { iosIdentifierTypeToAppsIdentifiers } from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/AppsIdentifiersFilter/utils";
import type { IAppsIosIdentifierFilter } from "app/pages/sales-intelligence/store/find-apps/types";

export const AppsIosIdentifiersFilterResult: React.FC<IFilterViewBaseModelProps<IAppsIosIdentifierFilter>> = ({
    value,
    onFilterUpdate,
    isExpanded,
}) => {
    const handleDelete = (type: IosIdentifierType) => (id: string) => {
        const updatedValue = {
            ...(value ?? {}),
            ...{ [type]: (value?.[type] || []).filter((value) => value !== id) },
        } as IAppsIosIdentifierFilter;
        onFilterUpdate(!updatedValue.bundleIds?.length && !updatedValue.trackIds?.length ? undefined : updatedValue);
    };

    const getChipItems = (type: IosIdentifierType) =>
        value?.[type]?.map((item) => ({ text: `${iosIdentifierTypeToAppsIdentifiers[type]}: ${item}`, id: item })) ??
        [];

    const trackIdsChips = getChipItems("trackIds");
    const bundleIdsChips = getChipItems("bundleIds");

    if (!value?.trackIds?.length && !value?.bundleIds?.length) {
        return null;
    }

    return (
        <>
            {trackIdsChips.length ? (
                <FlexRowWrap>
                    <LimitedChipItems
                        items={trackIdsChips}
                        onDelete={handleDelete("trackIds")}
                        maxItems={2}
                        delimiter={translate("si.find_apps.filters.identifier.OR")}
                        isTabExpanded={isExpanded}
                    />
                </FlexRowWrap>
            ) : null}
            {trackIdsChips.length && bundleIdsChips.length ? (
                <StyledDelimiter>{translate("si.find_apps.filters.identifier.OR")}</StyledDelimiter>
            ) : null}
            {bundleIdsChips.length ? (
                <FlexRowWrap>
                    <LimitedChipItems
                        items={bundleIdsChips}
                        onDelete={handleDelete("bundleIds")}
                        maxItems={2}
                        delimiter={translate("si.find_apps.filters.identifier.OR")}
                        isTabExpanded={isExpanded}
                    />
                </FlexRowWrap>
            ) : null}
        </>
    );
};
